<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Reports</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cib-read-the-docs" />
            Reports
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="From"
              label-for="report-periodFrom"
              :state="report.periodFrom.isValid"
            >
              <b-input-group>
                <b-form-datepicker
                  v-model="report.periodFrom.value" 
                  :max="report.periodFrom.maxValue"
                  :disabled="report.periodFrom.isDisabled"
                  id="report-periodFrom"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="report.periodFrom.isValid"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="report.periodFrom.timeValue"
                  now-button
                  locale="id"
                  :disabled="this.report.interval.value == 'daily'"
                ></b-form-timepicker>
              </b-input-group>
            </b-form-group>
          </CCol>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="To"
              label-for="report-periodTo"
              :state="report.periodTo.isValid"
            >
              <b-input-group>
                <b-form-datepicker
                  v-model="report.periodTo.value" 
                  :max="report.periodTo.maxValue"
                  :disabled="report.periodTo.isDisabled"
                  id="report-periodTo"
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  :state="report.periodTo.isValid"
                ></b-form-datepicker>
                <b-form-timepicker
                  v-model="report.periodTo.timeValue"
                  now-button
                  locale="id"
                  :disabled="this.report.interval.value == 'daily'"
                ></b-form-timepicker>
              </b-input-group>
            </b-form-group>
          </CCol>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="Camera"
              label-for="report-camera"
              :state="report.camera.isValid"
            >
              <b-form-select 
                v-model="report.camera.value" 
                :options="report.camera.options" 
                :state="report.camera.isValid"
                id="report-camera">
              </b-form-select>
            </b-form-group>
          </CCol>
          <CCol col="6">
            <b-form-group
              invalid-feedback="This input is required."
              label="Interval"
              label-for="report-interval"
              :state="report.interval.isValid"
            >
              <b-form-select 
                v-model="report.interval.value" 
                :options="report.interval.options"
                :state="report.interval.isValid"
                @change="onChangeInterval"
                id="report-interval">
              </b-form-select>
            </b-form-group>
          </CCol>
        </CRow>

        <CRow class="mt-1">
          <CCol class="text-center">
            <CButton color="primary" type="submit" style="width:7rem" :disabled="isSearching" @click="generateReport">
                <b-spinner small v-if="isSearching" />
                {{ isSearching ? 'Searching...' : 'Search' }}
              </CButton>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <h5><strong>{{ cards.items.totalTraffic.text }} : {{ cards.items.totalTraffic.value }}</strong></h5>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <h5>{{ cards.items.averageDailyTraffic.text }} : {{ cards.items.averageDailyTraffic.value }}</h5>
          </CCol>
        </CRow>

        <CRow>
          <CCol class="p-2" xl="12">
            <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <h5><strong>Vehicle List</strong></h5>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <h5>Total identified vehicle: {{ cards.items.identified_vehicles}}</h5>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="identifiedTable.items"
              :fields="identifiedTable.fields"
              :busy="!identifiedTable.isLoaded"
              :per-page="identifiedTable.perPage"
              :current-page="identifiedTable.currentPage"
            >
              <template slot="empty">
                <div v-if="!identifiedTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 + ((identifiedTable.currentPage-1)*10) }}
              </template>
              <template #cell(camera)="row">
                <div v-for="camera in report.camera.options">
                  <div v-if="row.item.camera_id == camera.value">{{ camera.text }}</div>
                </div>
              </template>
              <template #cell(vehicle_type)="row">
                {{ row.item.vehicle_type.charAt(0).toUpperCase() + row.item.vehicle_type.slice(1) }}
              </template>
              <template #cell(actions)="row">
                <CButton size="sm" color="secondary" style="color: white; margin-right: 0.5rem !important;" @click="getDetail(row.item)" class="btn-icon mr-2 custom-button-action">
                  Details
                </CButton> 
                <CButton size="sm" color="secondary" style="color: white;" class="btn-icon mr-2 custom-button-action" @click="trackItem(row.item.plate_number)">
                  Track
                </CButton> 
              </template>
            </b-table>
            <CCardFooter>
              <b-row>
                <b-col md="8" cols="12">
                  <div class="my-2">{{ identifiedTable.totalViewText }}</div>
                </b-col>
                <b-col md="4" cols="12">
                  <b-pagination class="mb-0" align="right"
                    v-model="identifiedTable.currentPage"
                    :total-rows="identifiedTable.totalRows"
                    :per-page="identifiedTable.perPage"
                  />
                </b-col>
              </b-row>
            </CCardFooter>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <h5>Total unidentified vehicle: {{ cards.items.unidentified_vehicles}}</h5>
          </CCol>
        </CRow>

        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="unidentifiedTable.items"
              :fields="unidentifiedTable.fields"
              :busy="!unidentifiedTable.isLoaded"
              :per-page="unidentifiedTable.perPage"
              :current-page="unidentifiedTable.currentPage"
            >
              <template slot="empty">
                <div v-if="!unidentifiedTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 + ((unidentifiedTable.currentPage-1)*10) }}
              </template>
              <template #cell(vehicle_type)="row">
                {{ row.item.vehicle_type.charAt(0).toUpperCase() + row.item.vehicle_type.slice(1) }}
              </template>
              <template #cell(actions)="row">
                <CButton size="sm" color="secondary" style="color: white; margin-right: 0.5rem !important;" @click="getUnidentifiedDetail(row.item)" class="btn-icon mr-2 custom-button-action">
                  Details
                </CButton> 
              </template>
            </b-table>
            <CCardFooter>
              <b-row>
                <b-col md="8" cols="12">
                  <div class="my-2">{{ unidentifiedTable.totalViewText }}</div>
                </b-col>
                <b-col md="4" cols="12">
                  <b-pagination class="mb-0" align="right"
                    v-model="unidentifiedTable.currentPage"
                    :total-rows="unidentifiedTable.totalRows"
                    :per-page="unidentifiedTable.perPage"
                  />
                </b-col>
              </b-row>
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showDetailModal" :centered="true">
        <div slot="header"><h5>View Vehicle Detail</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                label="Plate Number"
                label-for="plate-number"
              >
                <b-form-input
                  v-model="detail.plate_number"
                  id="plate-number"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Type"
                label-for="vehicle-type"
              >
                <b-form-input
                  v-model="detail.vehicle_type"
                  id="vehicle-type"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Camera"
                label-for="camera"
              >
                <b-form-input
                  v-model="detail.camera"
                  id="camera"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="First Tracked Time"
                label-for="first-tracked-time"
              >
                <b-form-input
                  v-model="detail.first_tracked_time"
                  id="first-tracked-time"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Last Tracked Time"
                label-for="last-tracked-time"
              >
                <b-form-input
                  v-model="detail.last_tracked_time"
                  id="last-tracked-time"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Confidence"
                label-for="plate-confidence"
              >
                <b-form-input
                  v-model="detail.plate_confidence"
                  id="plate-confidence"
                  :disabled="true"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.plate_image_in != null">
            <CCol sm="12" class="mb-2">
              <label>Plate Number Vehicle In:</label>
              <b-img thumbnail fluid-grow :src="detail.plate_image_in" alt="plate-vehicle-in"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.vehicle_image_in != null">
            <CCol sm="12" class="mb-2">
              <label>Vehicle In:</label>
              <b-img thumbnail fluid-grow :src="detail.vehicle_image_in" alt="vehicle-in"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.plate_image_out != null">
            <CCol sm="12" class="mb-2">
              <label>Plate Number Vehicle Out:</label>
              <b-img thumbnail fluid-grow :src="detail.plate_image_out" alt="plate-vehicle-out"></b-img>
            </CCol>
          </CRow>
          <CRow class="mt-2" v-if="detail.vehicle_image_out != null">
            <CCol sm="12" class="mb-2">
              <label>Vehicle Out:</label>
              <b-img thumbnail fluid-grow :src="detail.vehicle_image_out" alt="vehicle-out"></b-img>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showDetailModal = false">Back</CButton>
        </div>
      </CModal>
    </CForm>

  </CContainer>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Reports',
  
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isLoading: false,
      showDetailModal: false,

      options: {
        chart: {
          id: 'vuechart-example'
        },
        yaxis: {
          title: {
            text: 'Vehicle',
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: 'Date & Time',
            offsetY: 90
          },
        },
        legend: {
          position: 'top'
        }
      },
      series: [],

      isSearching: false,

      cards: {
        isLoaded: true, // NOTE: Set this to false in Production
        items: {
          totalTraffic: { value: 0, text: "Total Traffic" },
          averageDailyTraffic: { value: 0, text: "Average Traffic" },
          busiestDay: { value: '', text: "Busiest Day" },
          identified_vehicles: "",
          unidentified_vehicles: ""
        }
      },

      report: {
        periodFrom: {
          value: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
          timeValue: '00:00:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodFrom"
        },
        periodTo: {
          value: today,
          timeValue: '23:59:00',
          isValid: null,
          isDisabled: false,
          isRequired: true,
          minValue: '',
          maxValue: today,
          payloadKey: "periodTo"
        },
        camera: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [{ value: null, text: '--Please select a camera--', disabled: true }],
          payloadKey: "camera"
        },
        interval: {
          value: "daily",
          isValid: null,
          isRequired: true,
          options: [
            { value: "daily", text: "Daily" },
            { value: "hourly", text: "Hourly" },
            { value: "minutely", text: "By Minute" },
          ],
          payloadKey: "interval"
        },
      },

      detail: {
        plate_number: "",
        vehicle_type: "",
        camera: "",
        first_tracked_time: "",
        last_tracked_time: "",
        plate_confidence: "",
        plate_image_in: null,
        vehicle_image_in: null,
        plate_image_out: null,
        vehicle_image_out: null
      },
      
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      cameras: [],
      identifiedTable: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "plate_number", label: "Plate Number", sortable: true},
          {key: "vehicle_type", label: "Type", sortable: true},
          {key: "camera", label: "Camera", sortable: true },
          {key: "start_detected", label: "First Tracked Time", sortable: true },
          {key: "end_detected", label: "Last Tracked Time", sortable: true },
          {key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user"},
        ],

        items: [],
        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      unidentifiedTable: {
        totalViewText: '',
        isLoaded: true,
        fields: [
          {key: "index", label: "No.", sortable: false},
          {key: "vehicle_type", label: "Type", sortable: true},
          {key: "start_detected", label: "First Tracked Time", sortable: true },
          {key: "end_detected", label: "Last Tracked Time", sortable: true },
          {key: "actions", label: "Actions", sortable: false, class:"custom-column-action-user"},
        ],

        items: [],
        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onChangeInterval() {
      if (this.report.interval.value == 'daily') {
        this.report.periodFrom.timeValue = '00:00'
        this.report.periodTo.timeValue = '23:59'
      }  
    },

    trackItem(plate){
      this.$router.push({
        name: 'VehicleTracker',
        params: {
          plate_number: plate
        }
      });
    },

    getDetail(item) {
      this.isLoading = true

      // URL builder
      let postUrl = "/vehicle_list_detail"
      let obj = {
        plate_number: item.plate_number
      }

      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            let data = response.data.data

            this.detail.plate_number = item.plate_number
            this.detail.vehicle_type = item.vehicle_type.charAt(0).toUpperCase() + item.vehicle_type.slice(1)
            this.detail.first_tracked_time = item.start_detected
            this.detail.last_tracked_time = item.end_detected

            for (var x = 0; x < this.report.camera.options.length; x++) {
              if (this.report.camera.options[x].value == item.camera_id) {
                this.detail.camera = this.report.camera.options[x].text
                break;
              }
            }

            this.detail.plate_confidence = ((data.plate_number_confidence) * 100) + "%"
            this.detail.plate_image_in = data.plate_image_in
            this.detail.plate_image_out = data.plate_image_out
            this.detail.vehicle_image_in = data.vehicle_image_in
            this.detail.vehicle_image_out = data.vehicle_image_out

            this.showDetailModal = true
            
          } else{
            this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    getUnidentifiedDetail(item) {
      this.isLoading = true

      // URL builder
      let postUrl = "/vehicle_list_detail_unidentified"
      let obj = {
        id: item.id
      }

      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          if (response.data.success) {
            let data = response.data.data

            this.detail.plate_number = "UNIDENTIFIED"
            this.detail.vehicle_type = item.vehicle_type.charAt(0).toUpperCase() + item.vehicle_type.slice(1)
            this.detail.first_tracked_time = item.start_detected
            this.detail.last_tracked_time = item.end_detected

            for (var x = 0; x < this.report.camera.options.length; x++) {
              if (this.report.camera.options[x].value == data.camera_id[0]) {
                this.detail.camera = this.report.camera.options[x].text
                break;
              }
            }

            this.detail.plate_confidence = ((data.plate_number_confidence) * 100) + "%"
            this.detail.plate_image_in = data.plate_image_in
            this.detail.plate_image_out = data.plate_image_out
            this.detail.vehicle_image_in = data.vehicle_image_in
            this.detail.vehicle_image_out = data.vehicle_image_out

            this.showDetailModal = true
            
          } else{
            this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
          }
        } else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(response.data.message) ? response.data.message : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Pengambilan detail kendaraan gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading = false
      })
    },

    generateReport() {
      if (this.report.camera.value == null) {
        this.$helper.toastError(this, "Please select a camera!")
      }
      else {
        this.isSearching = true
        this.identifiedTable.isLoaded = false
        this.identifiedTable.items = []
        this.unidentifiedTable.isLoaded = false
        this.unidentifiedTable.items = []
        this.isLoading = true

        // URL builder
        let postUrl = "/report_chart"
        let postIdentifiedUrl = "/report_table_identified"
        let postUnidentifiedUrl = "/report_table_unidentified"

        let obj = {
          start_datetime: this.report.periodFrom.value + ' ' + this.$helper.showData(this.report.periodFrom.timeValue, "longTime"),
          end_datetime: this.report.periodTo.value + ' ' + this.$helper.showData(this.report.periodTo.timeValue, "longTime"),
          camera: this.report.camera.value,
          interval: this.report.interval.value,
        }

        let report_obj = {
          start_datetime: this.report.periodFrom.value + ' ' + this.$helper.showData(this.report.periodFrom.timeValue, "longTime"),
          end_datetime: this.report.periodTo.value + ' ' + this.$helper.showData(this.report.periodTo.timeValue, "longTime"),
          camera: this.report.camera.value
        }

        this.$axios.post(postUrl, obj).then(response => {
          if(response.status == 200){
            let chartData = response.data.data.chart
            let seriesData = [
              {
                name: 'Total Vehicle',
                data: []
              }
            ]

            let optionsData = {
              chart: {
                id: 'vehicle-chart'
              },
              yaxis: {
                title: {
                  text: 'Vehicle',
                },
              },
              xaxis: {
                categories: [],
                title: {
                  text: 'Date & Time',
                  offsetY: 90
                },
              },
              legend: {
                position: 'top'
              }
            }

            for (var x = 0; x < chartData.all_vehicle.length; x++) {
              optionsData.xaxis.categories.push(this.$helper.showData(chartData.all_vehicle[x].datetime, "longDate"))
              seriesData[0].data.push(chartData.all_vehicle[x].count)
            }

            this.cards.items.totalTraffic.value = this.$helper.thousandSeparator(response.data.data.total_traffic)
            this.cards.items.averageDailyTraffic.value = this.$helper.thousandSeparator(response.data.data.average_traffic)
            this.series = seriesData
            this.options = optionsData
            this.isLoading = false         
          }
          else{
            // this.errorAction(response)
            this.$helper.toastError(this, "Load Laporan Gagal! " + (response.data.message ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          // this.errorAction(error)
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Laporan Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Laporan Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })

        this.$axios.post(postIdentifiedUrl, report_obj).then(response => {
          if(response.status == 200){
            this.identifiedTable.items = response.data.data
            this.identifiedTable.totalRows = response.data.data.length
            this.identifiedTable.totalPages = response.data.data.length % this.identifiedTable.perPage
            this.cards.items.identified_vehicles = this.$helper.thousandSeparator(response.data.data.length)
          }
          else{
            // this.errorAction(response)
            this.$helper.toastError(this, "Load Laporan Gagal! " + (response.data.message ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          // this.errorAction(error)
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Laporan Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Laporan Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.identifiedTable.isLoaded = true
          this.isSearching = false
        })

        this.$axios.post(postUnidentifiedUrl, report_obj).then(response => {
          if(response.status == 200){
            this.unidentifiedTable.items = response.data.data
            this.unidentifiedTable.totalRows = response.data.data.length
            this.unidentifiedTable.totalPages = response.data.data.length % this.unidentifiedTable.perPage
            this.cards.items.unidentified_vehicles = this.$helper.thousandSeparator(response.data.data.length)
          }
          else{
            // this.errorAction(response)
            this.$helper.toastError(this, "Load Laporan Gagal! " + (response.data.message ? response.data.message : "Unknown Error"))
          }
        })
        .catch(error => {
          // this.errorAction(error)
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Laporan Gagal! " +  (!this.$helper.isEmpty(error.response.data.message) ? error.response.data.message : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Laporan Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.unidentifiedTable.isLoaded = true
        })
      }
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

    
    recalculateIdentified() {
      let pg = this.identifiedTable.currentPage - 1

      let prev = pg * this.identifiedTable.perPage + 1
      let limit = pg * this.identifiedTable.perPage + this.identifiedTable.perPage
      if (limit > this.identifiedTable.totalRows) limit = this.identifiedTable.totalRows
      if (this.identifiedTable.totalRows == 0) prev = 0
      this.identifiedTable.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.identifiedTable.totalRows + " entri"
    },

    recalculateUnidentified() {
      let pg = this.unidentifiedTable.currentPage - 1

      let prev = pg * this.unidentifiedTable.perPage + 1
      let limit = pg * this.unidentifiedTable.perPage + this.unidentifiedTable.perPage
      if (limit > this.unidentifiedTable.totalRows) limit = this.unidentifiedTable.totalRows
      if (this.unidentifiedTable.totalRows == 0) prev = 0
      this.unidentifiedTable.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.unidentifiedTable.totalRows + " entri"
    },

    getCameras() {
      // URL builder
      let getUrl = "/cameras"

      return this.$axios.get(getUrl).then(response => {
        if(response.status == 200){
          let data = response.data.data
          for (var x = 0; x < data.length; x++) {
            this.report.camera.options.push({
              value: data[x].id, 
              text: data[x].name
            })
          }
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "Load Camera Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Camera Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Load Camera Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
    },
  },
  computed: {
    identifiedTotalRows() {
      return this.identifiedTable.totalRows;
    },
    identifiedCurrentPage() {
      return this.identifiedTable.currentPage;
    },
    unidentifiedTotalRows() {
      return this.unidentifiedTable.totalRows;
    },
    unidentifiedCurrentPage() {
      return this.unidentifiedTable.currentPage;
    }
  },
  watch: {

    identifiedTotalRows(newVal) {
      this.recalculateIdentified()
    },

    identifiedCurrentPage(newVal) {
      this.recalculateIdentified()
    },

    unidentifiedTotalRows(newVal) {
      this.recalculateUnidentified()
    },

    unidentifiedCurrentPage(newVal) {
      this.recalculateUnidentified()
    },

  },

  created() {
    this.getCameras()
  }
}
</script>

<style>

</style>
